import promoCharacters from './sticky-promo-img.webp';
import promoCharactersDesktop from './promo-characters-desktop.webp';
import topBannerImage from './top-banner-image.webp';
import topBannerImageMobile from './top-banner-image-mobile.webp';
import topBannerImageDesktop from './top-banner-image-desktop.webp';
import canada from './canada.webp';
import stopWatch from './stop-watch.webp';
import stars from './stars.webp';
import piggyBank from './piggy-bank.webp';
import bigWinGame1 from './big-win-game-1.webp';
import bigWinGame3 from './big-win-game-3.webp';
import bigWinGame4 from './big-win-game-4.webp';
import bigWinGame5 from './big-win-game-5.webp';

import rewardsCashDesktop from './earnRewards/rewards-cash-desktop.webp';
import rewardsCashMob from './earnRewards/rewards-cash-mobile.webp';
import rewardsCoinsDesktop from './earnRewards/rewards-coins-desktop.webp';
import rewardsCoinsMob from './earnRewards/rewards-coins-mobile.webp';
import rewardsSpinsDesktop from './earnRewards/rewards-spins-desktop.webp';
import rewardsSpinsMob from './earnRewards/rewards-spins-mobile.webp';
import rewardsWheelDesktop from './earnRewards/rewards-wheel-desktop.webp';
import rewardsWheelMob from './earnRewards/rewards-wheel-mobile.webp';
import sparkleLanding from './earnRewards/sparkle-landing.webp';

import messages from './messages.webp';
import lock from './lock.webp';
import slot from './slot.webp';

// providers
import fortheplayersV2 from './providers/4-the-player.webp';
import agsV2 from './providers/ags.webp';
import avataruxV2 from './providers/avatar-ux.webp';
import backseatGamingV2 from './providers/backseat-gaming.webp';
import bigTimeGamingV2 from './providers/big-time-gaming.webp';
import blueGuruGamesV2 from './providers/blue-guru.webp';
import blueprintV2 from './providers/blueprint.webp';
import everiV2 from './providers/everi.webp';
import fantasmaGamesV2 from './providers/fantasma-games.webp';
import fourLeafGamingV2 from './providers/four-leaf-gaming.webp';
import gamesGlobalV2 from './providers/games-global.webp';
import goldenRockV2 from './providers/golden-rock-studios.webp';
import hacksawV2 from './providers/hacksaw.webp';
import igtV2 from './providers/igt.webp';
import inspiredV2 from './providers/inspired.webp';
import jadeRabbitV2 from './providers/jade-rabbit-studio.webp';
import kitsuneStudioV2 from './providers/kitsune-studio.webp';
import lightAndWonderV2 from './providers/light-and-wonder.webp';
import netentV2 from './providers/net-ent.webp';
import noLimitCityV2 from './providers/nolimit-city.webp';
import nownowGamingV2 from './providers/nownow-gaming.webp';
import peterAndSonsV2 from './providers/peter-and-sons.webp';
import playngoV2 from './providers/play-n-go.webp';
import playsonV2 from './providers/playson.webp';
import pragmaticV2 from './providers/pragmatic-play.webp';
import printStudiosV2 from './providers/print-studios.webp';
import redTigerV2 from './providers/red-tiger.webp';
import reelPlayV2 from './providers/reel-play.webp';
import relaxV2 from './providers/relax.webp';
import silverbackGamingV2 from './providers/silverback.webp';
import slingoV2 from './providers/slingo.webp';
import spinberryV2 from './providers/spinberry.webp';
import stakelogicV2 from './providers/stakelogic.webp';
import stormGamingV2 from './providers/storm-gaming.webp';
import trustyGamingV2 from './providers/trusty-games.webp';
import wazdanV2 from './providers/wazdan.webp';
import wizardV2 from './providers/wizard-games.webp';
import dwg from './providers/dwg.webp';
import pariplay from './providers/pariplay.webp';
import aristocrat from './providers/aristocrat.webp';
import swintt from './providers/swintt.webp';
import konami from './providers/konami.webp';
import thunderKick from './providers/thunderkick.webp';
import onex2gaming from './providers/1x2gaming.webp';
import elk from './providers/elk.webp';
import bragg from './providers/bragg.webp';

import provider1 from './providers/x2/1.webp';
import provider2 from './providers/x2/2.webp';
import provider3 from './providers/x2/3.webp';
import provider4 from './providers/x2/4.webp';
import provider5 from './providers/x2/5.webp';
import provider6 from './providers/x2/6.webp';
import provider7 from './providers/x2/7.webp';
import provider8 from './providers/x2/8.webp';
import provider9 from './providers/x2/9.webp';
import provider10 from './providers/x2/10.webp';
import provider11 from './providers/x2/11.webp';
import provider12 from './providers/x2/12.webp';
import provider13 from './providers/x2/13.webp';
import provider14 from './providers/x2/14.webp';
import provider15 from './providers/x2/15.webp';
import provider16 from './providers/x2/16.webp';
import provider17 from './providers/x2/17.webp';
import provider18 from './providers/x2/18.webp';
import provider19 from './providers/x2/19.webp';
import provider20 from './providers/x2/20.webp';
import provider21 from './providers/x2/21.webp';
import provider22 from './providers/x2/22.webp';
import provider23 from './providers/x2/23.webp';

//Games categories
import mostPopularGame1 from './games/mp-game-1.webp';
import mostPopularGame2 from './games/mp-game-2.webp';
import mostPopularGame3 from './games/mp-game-3.webp';
import mostPopularGame4 from './games/mp-game-4.webp';
import mostPopularGame5 from './games/mp-game-5.webp';
import mostPopularGame6 from './games/mp-game-6.webp';
import mostPopularGame7 from './games/mp-game-7.webp';
import mostPopularGame8 from './games/mp-game-8.webp';
import jungleGame1 from './games/p-jp-1.webp';
import jungleGame2 from './games/p-jp-2.webp';
import jungleGame3 from './games/p-jp-3.webp';
import jungleGame4 from './games/p-jp-4.webp';
import jungleGame5 from './games/p-jp-5.webp';
import jungleGame6 from './games/p-jp-6.webp';
import jungleGame7 from './games/p-jp-7.webp';
import jungleGame8 from './games/p-jp-8.webp';
import featureBuyGame1 from './games/feature-buy-1.webp';
import featureBuyGame2 from './games/feature-buy-2.webp';
import featureBuyGame3 from './games/feature-buy-3.webp';
import featureBuyGame4 from './games/feature-buy-4.webp';
import featureBuyGame5 from './games/feature-buy-5.webp';
import featureBuyGame6 from './games/feature-buy-6.webp';
import featureBuyGame7 from './games/feature-buy-7.webp';
import featureBuyGame8 from './games/feature-buy-8.webp';

import seeAllPromos from './see-all-promos.webp';
import downloadAppDesktop from './download-app-desktop.webp';
import downloadAppMobile from './download-app-mob.webp';
import leafsLogo from './leafs-logo.webp';
import ball from './ball.webp';
import handWithHearts from './hand-with-hearts.webp';
import bonanzaCoinFront from './bonanza-coin-front.webp';
import games from './2000Games.webp';
import rewards from './loyaltyRewards.webp';
import freebies from './dailyFreebies.webp';
import freeCoins from './freeCoins.webp';
import stickyBannerDesktop from './stickyBannerDesktop.webp';
import whyBonanza from './whyBonanza.webp';

export default {
  promoCharacters,
  promoCharactersDesktop,
  topBannerImage,
  topBannerImageMobile,
  topBannerImageDesktop,
  canada,
  stopWatch,
  stars,
  piggyBank,
  bigWinGame1,
  bigWinGame3,
  bigWinGame4,
  bigWinGame5,
  rewardsCashDesktop,
  rewardsCashMob,
  rewardsCoinsDesktop,
  rewardsCoinsMob,
  rewardsSpinsDesktop,
  rewardsSpinsMob,
  rewardsWheelDesktop,
  rewardsWheelMob,
  messages,
  lock,
  slot,
  fortheplayersV2,
  agsV2,
  avataruxV2,
  backseatGamingV2,
  bigTimeGamingV2,
  blueGuruGamesV2,
  blueprintV2,
  everiV2,
  fantasmaGamesV2,
  fourLeafGamingV2,
  gamesGlobalV2,
  goldenRockV2,
  hacksawV2,
  igtV2,
  inspiredV2,
  jadeRabbitV2,
  kitsuneStudioV2,
  lightAndWonderV2,
  netentV2,
  noLimitCityV2,
  nownowGamingV2,
  peterAndSonsV2,
  playngoV2,
  playsonV2,
  pragmaticV2,
  printStudiosV2,
  redTigerV2,
  reelPlayV2,
  relaxV2,
  silverbackGamingV2,
  slingoV2,
  spinberryV2,
  stakelogicV2,
  stormGamingV2,
  trustyGamingV2,
  wazdanV2,
  wizardV2,
  konami,
  thunderKick,
  onex2gaming,
  elk,
  bragg,
  dwg,
  pariplay,
  aristocrat,
  swintt,
  provider1,
  provider2,
  provider3,
  provider4,
  provider5,
  provider6,
  provider7,
  provider8,
  provider9,
  provider10,
  provider11,
  provider12,
  provider13,
  provider14,
  provider15,
  provider16,
  provider17,
  provider18,
  provider19,
  provider20,
  provider21,
  provider22,
  provider23,
  mostPopularGame1,
  mostPopularGame2,
  mostPopularGame3,
  mostPopularGame4,
  mostPopularGame5,
  mostPopularGame6,
  mostPopularGame7,
  mostPopularGame8,
  jungleGame1,
  jungleGame2,
  jungleGame3,
  jungleGame4,
  jungleGame5,
  jungleGame6,
  jungleGame7,
  jungleGame8,
  featureBuyGame1,
  featureBuyGame2,
  featureBuyGame3,
  featureBuyGame4,
  featureBuyGame5,
  featureBuyGame6,
  featureBuyGame7,
  featureBuyGame8,
  seeAllPromos,
  downloadAppDesktop,
  downloadAppMobile,
  leafsLogo,
  ball,
  handWithHearts,
  bonanzaCoinFront,
  games,
  rewards,
  freebies,
  freeCoins,
  sparkleLanding,
  stickyBannerDesktop,
  whyBonanza,
};
